const Config = require('~config/default.env').default;
import axios from 'axios';

const getSimiliarProducts = (params) => {
  return axios.get(`${Config.MS_ANALYTICS_API_URL}/product/similar`, {
    params,
  });
};

const setSessionMe = (payload) => {
  return axios.post(`${Config.MS_ANALYTICS_API_URL}/sessions/me`, payload);
};

const postSessionMe = ({ guild, payload }) => {
  return axios.post(
    `${Config.MS_ANALYTICS_API_URL}/sessions/me/${guild}`,
    payload,
  );
};

const postGenerateSingleLink = (params) => {
  return axios
    .post(`${Config.MS_ANALYTICS_API_URL}/adjust-automation/deep-links`, params)
    .then(({ data }) => data.data)
    .catch((error) => {
      console.error('Error generating single link:', error);
      throw error;
    });
};

export const Analytics = {
  getSimiliarProducts,
  setSessionMe,
  postSessionMe,
  postGenerateSingleLink,
};
